import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import { Divider, Spinner, Typography } from '@telus-uds/components-web';

import request from '../../utils/request';

import { ContentWrapper, Box } from '../../design/css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { orderStatus, quoteStatus } from '../../utils/constant';
import { getFormattedDate } from '../../utils/utils';
import useFetchContentfulData from '../../hooks/useFetchContentfulData';

import Table from './Table';
import Pagination from '../../salesRepDashboard/Pagination';
import SearchBar from './components/searchBar';
import Filters from './components/filters';

const BusinessAppOrders = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;

  const {
    incomplete,
    pendingValidation,
    waitingOnCredit,
    waitingOnSales,
    contractSigned,
    contractSent,
    orderCanceled,
    contractExpired,
    orderInstalled,
    orderPlaced,
    orderActivated,
    orderShipped,
    orderCompleted,
    orderSubmitted
  } = orderStatus;

  const { approved } = quoteStatus;

  const { data: pageLayout } = useFetchContentfulData(
    'businessAppSalesRepDashboard'
  );
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [filters, setFilters] = useState({
    productInOrderFor: [],
    status: [],
    createdBy: [],
    province: [],
    channelId: [],
    dealership: [],
    filterCriteria: '',
    endDateOpenDate: '',
    endDateSubmissionDate: '',
    startDateOpenDate: '',
    startDateSubmissionDate: ''
  });

  const getPayload = () => {
    const payload = {
      ...filters,
      pageNumber,
      pageSize: 10,
      type: 'BA',
      status: filters.status.length || [
        incomplete,
        pendingValidation,
        waitingOnCredit,
        waitingOnSales,
        contractSigned,
        contractSent,
        orderCanceled,
        contractExpired,
        orderInstalled,
        orderPlaced,
        orderActivated,
        orderShipped,
        orderCompleted,
        orderSubmitted,
        approved
      ]
    };

    if (filters.createdBy) payload.createdBy = _.get(filters, 'createdBy.0.id');
    if (filters.province)
      payload.province = filters.province.map(row => row.label);
    if (filters.channelId)
      payload.channelId = filters.channelId.map(row => row.value);
    if (filters.dealership)
      payload.dealership = filters.dealership.map(row => row.value);

    if (filters.productInOrderFor)
      payload.productInOrderFor = filters.productInOrderFor.map(
        row => row.value
      );
    if (filters.status.length)
      payload.status = filters.status.map(row => row.value);
    if (filters.createdBy)
      payload.createdBy = filters.createdBy.map(row => row.value);

    if (filters.startDateOpenDate)
      payload.startDate = getFormattedDate(filters.startDateOpenDate);

    if (filters.endDateOpenDate)
      payload.endDate = getFormattedDate(filters.endDateOpenDate);

    if (filters.startDateSubmissionDate) {
      payload.startDate = getFormattedDate(filters.startDateSubmissionDate);
    }
    if (filters.endDateSubmissionDate)
      payload.endDate = getFormattedDate(filters.endDateSubmissionDate);

    if (filters.startDateOpenDate || filters.endDateOpenDate)
      payload.filterCriteria = 'createdAt';

    if (filters.startDateSubmissionDate || filters.endDateSubmissionDate)
      payload.filterCriteria = 'validatedAt';

    delete payload.startDateOpenDate;
    delete payload.endDateOpenDate;
    delete payload.endDateSubmissionDate;
    delete payload.startDateSubmissionDate;
    return payload;
  };

  const setOrders = data => {
    setOrdersList(_.get(data, 'data.results', []));
    setTotalOrders(_.get(data, 'data.totalCount', 0));
    setPageNumber(1);
  };

  const fetchOrders = () => {
    setPageLoading(true);
    request
      .post('/orders/filter', getPayload())
      .then(response => {
        setOrdersList(_.get(response, 'data.results', []));
        setTotalOrders(_.get(response, 'data.totalCount', 0));
        setPageLoading(false);
      })
      .catch(() => {
        setPageLoading(false);
      });
  };

  useEffect(() => {
    fetchOrders();
  }, [pageNumber]);

  return (
    <>
    <Divider space={1} variant={{ inverse: true }} />
      <ContentWrapper>
        <Box>
          <Filters
            setOrders={setOrders}
            filters={filters}
            setFilters={setFilters}
            getPayload={getPayload}
          />
          <Divider space={1} variant={{ inverse: true }} />
          <SearchBar setOrders={setOrders} fetchOrders={fetchOrders} />
          {pageLoading && <Spinner show label="Loading Orders..." />}
          {!pageLoading && ordersList.length === 0 ? (
            <Typography heading="h3" variant={{ size: 'h3' }} block>{noOrders}</Typography>
          ) : (
            <>
              {!pageLoading && (
                <div className="table-container-main">
                  <Table
                    pageLayout={pageLayout}
                    data={ordersList}
                    fetchOrders={fetchOrders}
                    totalOrders={totalOrders}
                  />
                  <Pagination
                    ordersPerPage={_.get(pageLayout, 'ordersPerPage', 10)}
                    totalOrders={totalOrders}
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                  />
                </div>
              )}
            </>
          )}
        </Box>
      </ContentWrapper>
    </>
  );
};

export default BusinessAppOrders;
